import React from "react";
import { Download } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DOCS = [
  {
    key: "catalogue",
    title: "Wholesale catalogue",
    blurb: "Every kit and product with SKUs and AUD pricing, ex and inc GST.",
    file: "/docs/ei-battery-catalogue.pdf",
    thumb: "/docs/thumbs/catalogue.png",
    meta: "20 pages · 2.2 MB",
  },
  {
    key: "brochure",
    title: "Trade brochure",
    blurb: "The short version — product range, pricing and how we supply.",
    file: "/docs/ei-battery-dl-brochure.pdf",
    thumb: "/docs/thumbs/brochure.png",
    meta: "2 pages · 16 MB",
  },
  {
    key: "shipping-terms",
    title: "Shipping and freight terms",
    blurb: "How freight is calculated, what is charged and your collection options.",
    file: "/docs/ei-battery-shipping-information-and-freight-terms.pdf",
    thumb: "/docs/thumbs/shipping-terms.png",
    meta: "3 pages · 0.2 MB",
  },
];

const track = (key) => {
  axios.post(`${API}/downloads/${key}`).catch(() => {});
};

export const DownloadCards = () => (
  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="download-cards">
    {DOCS.map((doc) => (
      <a
        key={doc.key}
        href={doc.file}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track(doc.key)}
        className="group flex flex-col overflow-hidden rounded-sm border border-ei-mist bg-white transition-all duration-300 hover:-translate-y-1 hover:border-ei-navy/40 hover:shadow-xl"
        data-testid={`download-card-${doc.key}`}
      >
        <div className="aspect-[4/3] overflow-hidden bg-ei-navy/5">
          <img
            src={doc.thumb}
            alt={`First page of the EI Battery ${doc.title.toLowerCase()}`}
            loading="lazy"
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            data-testid={`download-thumb-${doc.key}`}
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          <h3 className="font-display text-base font-bold text-ei-navy">{doc.title}</h3>
          <p className="mt-1.5 flex-1 text-sm leading-relaxed text-ei-graphite/80">{doc.blurb}</p>
          <span className="mt-4 inline-flex items-center gap-2 font-display text-sm font-bold text-ei-navy">
            <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            Download PDF
          </span>
          <span className="mt-1 text-xs text-ei-graphite/55">{doc.meta}</span>
        </div>
      </a>
    ))}
  </div>
);
